import { Spinner as MofoSpinner } from "@workspace/ui/components/atoms/spinner"
import { appLoadingLabel } from "@workspace/ui/lib/practiceApps"

/**
 * The dashboard's waits — a page's code, the sign-in check, an app opening —
 * as in-game (client 2026-11-03): its spinner on white over the whole
 * screen, naming the app being opened ("Loading Linebacker"), like the
 * index.html boot screen before it and the app's own loading screen after.
 */
export const Spinner = ({ label }: { label?: string } = {}) => (
	<MofoSpinner label={label ?? appLoadingLabel()} fullScreen className="z-[120000]" />
)
